// No frontend JS needed — the trigger is a plain <a target="_blank">.
